import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useTrainingRegisterResources } from 'components/contexts/TrainingRegisterResourceManagementContext';

export default function AdditionalDestroyModalContent({
  hasELearningBookings,
}) {
  const { isMultiDivisionAccount } = useTrainingRegisterResources();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'courses.AdditionalDestroyModalContent',
  });

  return (
    hasELearningBookings ?
      <p className='tw-m-0 tw-mt-5 tw-rounded-lg tw-border-0 tw-bg-red-025 tw-p-3 tw-text-red-800'>
        {i18nT('eLearningBookings')}
      </p>
    : isMultiDivisionAccount ?
      <>
        <p className='tw-mt-6 tw-text-m tw-font-semibold tw-text-red-700'>
          {i18nT('multiDivisionAccount.warning')}
        </p>
        <ul className='tw-m-0 tw-mt-2 tw-rounded-lg tw-border-0 tw-bg-red-025 tw-p-3 tw-text-red-800'>
          <li className='tw-ml-4'>
            {i18nT('multiDivisionAccount.listItemOne')}
          </li>
          <li className='tw-ml-4'>
            {i18nT('multiDivisionAccount.listItemTwo')}
          </li>
        </ul>
      </>
    : null
  );
}

AdditionalDestroyModalContent.propTypes = {
  hasELearningBookings: PropTypes.bool.isRequired,
};
